import { Component, type ReactNode } from 'react'
import { isScreenshotEntrypoint } from '../../config'

// The Frame API polls window.__screenshot_render_error__ and fails the render
// at once when it is set, instead of waiting out the readiness timeout.
// Several parts of the scene report errors; each owns its own entry so one
// part clearing its error never hides another part's.
const errors = new Map<string, string>()

export function setScreenshotRenderError(source: string, message: string | null) {
  if (message) errors.set(source, message)
  else errors.delete(source)
  if (typeof window === 'undefined' || !isScreenshotEntrypoint()) return
  ;(window as any).__screenshot_render_error__ = errors.values().next().value ?? null
}

export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : String(error)
}

/**
 * Catches errors thrown while rendering the screenshot scene, such as a 3D
 * model that fails to load ("Could not load …fbx: unexpected EOF"), and
 * reports them so the screenshot fails in seconds with the real cause.
 */
export class ScreenshotErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  override componentDidCatch(error: unknown) {
    console.error('[screenshot] scene failed to render', error)
    setScreenshotRenderError('scene', errorMessage(error))
  }

  override render() {
    return this.state.failed ? null : this.props.children
  }
}
